import React, { useState } from "react";
import { useTranslation, LANGUAGES } from "../i18n";
import { supportsFlagEmojis } from "../utils/flagEmojiSupport";

function LanguageToggle() {
  const { language, setLanguage } = useTranslation();
  const [useTextFallback] = useState(() => !supportsFlagEmojis());

  return (
    <div
      className={`language-toggle${
        useTextFallback ? " language-toggle--fallback" : ""
      }`}
      role="group"
      aria-label="Language"
    >
      {Object.values(LANGUAGES).map((lang) => (
        <button
          key={lang.code}
          type="button"
          className={`language-toggle-btn language-toggle-btn--${lang.code} ${
            language === lang.code ? "active" : ""
          }`}
          onClick={() => setLanguage(lang.code)}
          aria-label={lang.label}
          aria-pressed={language === lang.code}
          title={lang.label}
        >
          <span className="language-flag" aria-hidden="true">
            {lang.flag}
          </span>
          <span className="language-code" aria-hidden="true">
            {lang.shortLabel}
          </span>
        </button>
      ))}
    </div>
  );
}

export default LanguageToggle;
